import React from 'react';
import {
	Box,
	Divider,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
	Typography,
} from '@mui/material';
import {
	ClubDpRewardsCardLabelSX,
	ClubDpRewardsDividerSX,
	ClubDpRewardsTableAmountSX,
	ClubDpRewardsTitleSX,
} from '@/components/content/Account/styles/clubDpRewards';

interface Transaction {
	date: string;
	totalAmount: number;
	amount: number;
	hour: string;
	storeName: string;
	typeId: number;
	type: string;
	ticketId: string;
	points: number;
}

interface LatestMovementsTableProps {
	latestMovements: Transaction[];
}

export const LatestMovementsTable: React.FC<LatestMovementsTableProps> = ({ latestMovements }) => (
	<Stack>
		<Box sx={ClubDpRewardsDividerSX}>
			<Divider />
		</Box>
		<Typography component={'h2'} sx={ClubDpRewardsTitleSX}>
			{'ÚLTIMOS MOVIMIENTOS'}
		</Typography>
		<TableContainer>
			<Table>
				<TableBody>
					{latestMovements.map((transaction: any, index: any) => (
						<TableRow
							key={transaction.ticketId}
							sx={{
								backgroundColor: index % 2 === 0 ? '#F8FCFF' : '#F2F8FF',
								'& td': { border: 'none' },
							}}
						>
							<TableCell>
								{transaction.date}
								<Typography sx={ClubDpRewardsCardLabelSX}>
									{`${transaction.storeName} - ${transaction.hour}`}
								</Typography>
							</TableCell>
							<TableCell sx={{ textAlign: 'right', paddingRight: '16px' }}>
								<Typography>{'Acumulaste'}</Typography>
								<Typography
									sx={ClubDpRewardsTableAmountSX}
								>{`${transaction.amount} puntos`}</Typography>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	</Stack>
);
